module.exports = __webpack_public_path__ + "static/media/arrow-down-right.4683f286.svg";